
var cwMjs=window.cwMjs || {};

cwMjs.common={
    ajaxSetup : function(){
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    },

    showNav: function () {
        $('.btn-show-nav').on('click', function () {
            $('header nav').slideToggle(200);
        });
    },

    switchToWeb : function(){
        $('.switch-to-web').on('click', function(e){
            e.preventDefault();
            var url = window.location.href.toString().replace('m','www');
            var list = url.split('/');
            if(list.pop() == 'special'){
                url += '.html';
            }
            Cookies.set('jump_key', 'desk', { domain: 'hswh.org.cn', expires: 1 });
            window.location.href = url;
        });
    },

    isWeiXin : function (){
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            return true;
        }else{
            return false;
        }
    }

    ,fixedFooter: function () {
        initFooter();
        function initFooter(){
            var winH=$(window).height();
            var bodyH=$(document.body).height();
            var footerH=$('footer').height();

            if(winH>=bodyH+footerH || !$('footer').hasClass('fixed-footer') && winH>=bodyH){
                $('footer').css({position:'fixed',width:'100%',left:0,bottom:0}).addClass('fixed-footer');
            }else if($('footer').hasClass('fixed-footer') && winH<bodyH+footerH){
                $('footer').css({position:'static',left:'auto',bottom:'auto'}).removeClass('fixed-footer');
            }
        }

        $(window).on('resize', function () {
            initFooter();
        })
    }

    ,backTop: function () {
        var $btn=$('.btn-back-top');

        $btn.on('click', function () {
            $('html,body').animate({scrollTop:0},400);
        });

        $(window).on('scroll', function () {
            var scrollTop=$(window).scrollTop();
            var limit=600;

            if(scrollTop>limit && $btn.hasClass('out-hide') ){
                $btn.removeClass('out-hide');
                return;
            }

            if(scrollTop<=limit && !$btn.hasClass('out-hide') ){
                $btn.addClass('out-hide');
            }
        });
    },

    open_side: function(){
        var $btn_side=$('header .btn_side');
        var $box_side=$('#nav_model');
        var $body=$('body');

        $box_side.find('.mask').on('click',function () {
            $box_side.removeClass('open');
            $body.removeClass('fixed')
        })

        $btn_side.on('click',function (e) {
            $box_side.addClass('open');
            $body.addClass('fixed');
        })
    }
}